// The Follow-ups screen's data — GET /api/followups/board (client, 2026-10-30).
// Server rules: src/shared/followups/board.js.
import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

export type FollowupBucket = 'overdue' | 'today' | 'upcoming' | 'done';
export type BoardScope = 'mine' | 'team' | 'all';

export interface BoardFollowup {
  _id: string;
  parentType: string;
  parentId: string;
  followupNote: string;
  details?: string;
  followupDate: string;
  status: string;
  outcome?: string;
  customerResponse?: string;
  noNextReason?: string;
  followupCategory?: string;
  contactMethod?: string;
  closingDate?: string | null;
  representativeId?: string;
  representativeName?: string;
  contactPersonName?: string;
  contactPersonPhone?: string;
  bucket: FollowupBucket;
  link: string | null;
  parentSummary?: { label?: string; number?: string; company?: string; contactName?: string; phone?: string; email?: string };
}

/** Open work with no next follow-up: a lead / deal, a sent quotation or proforma, a sample out for trial. */
export interface MissingItem {
  kind: 'record' | 'quotation' | 'proforma' | 'sample';
  parentType: string;
  id: string;
  title: string;
  sub?: string;
  date?: string | null;
  ageDays?: number | null;
  amount?: number;
  ownerId?: string;
  ownerName?: string;
  link: string | null;
}

export interface FollowupBoard {
  scope: BoardScope;
  canWiden: boolean;
  doneDays: number;
  employees: Array<{ _id: string; name: string }>;
  followups: BoardFollowup[];
  missing: MissingItem[];
}

export function useFollowupBoard(scope: BoardScope, doneDays: number) {
  return useQuery({
    // Under 'followups' so closing or adding one anywhere refreshes this screen.
    queryKey: ['followups', 'board', scope, doneDays],
    queryFn: async () => (await api.get<FollowupBoard>('/api/followups/board', { params: { scope, doneDays } })).data,
    staleTime: 30_000,
  });
}
